import FormGroup from './FormGroup';

export * from './FormGroup';
export * from './PasswordLostLabel';
export { default as PasswordLostLabel } from './PasswordLostLabel';

export default FormGroup;
